export default __webpack_public_path__ + "static/2-314e13cb8fe12457e791da85a576c26c.png";